import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { POINT_TYPES } from 'ui-addon-upgrades/ums/types';
import { mainBreakpoints } from '../components/common/ProductInfoContainer';
import UpgradeConfigBannerContent from './UpgradeConfigBannerContent';
import UpgradeConfigContent from './UpgradeConfigContent';
import UpgradeConfigContentGenericSuiteStarter from './UpgradeConfigContentGenericSuiteStarter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeroBackground = styled.div.withConfig({
  displayName: "UpgradeHeroBanner__HeroBackground",
  componentId: "sc-1a4ztnm-0"
})(["width:100%;z-index:-1;", ""], ({
  hideBackground
}) => `background-color: ${hideBackground ? '' : GYPSUM}`);
const ContentContainer = styled.div.withConfig({
  displayName: "UpgradeHeroBanner__ContentContainer",
  componentId: "sc-1a4ztnm-1"
})(["", ""], mainBreakpoints);
const UpgradeHeroBanner = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  hideBackground = false
}) => {
  return /*#__PURE__*/_jsx(HeroBackground, {
    hideBackground: hideBackground,
    children: /*#__PURE__*/_jsxs(ContentContainer, {
      className: "m-x-auto",
      children: [upgradeConfig.pointType === POINT_TYPES.USAGE_LIMIT_BANNER && /*#__PURE__*/_jsx(UpgradeConfigBannerContent, {
        upgradePointApiName: upgradePointApiName,
        upgradeConfig: upgradeConfig,
        purchaseMotions: purchaseMotions,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
      }), upgradeConfig.pointType === POINT_TYPES.MODAL && /*#__PURE__*/_jsx(UpgradeConfigContent, {
        upgradePointApiName: upgradePointApiName,
        upgradeConfig: upgradeConfig,
        purchaseMotions: purchaseMotions,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
      }), upgradeConfig.pointType === POINT_TYPES.REMOVE_BRANDING_BANNER && /*#__PURE__*/_jsx(UpgradeConfigContentGenericSuiteStarter, {
        upgradePointApiName: upgradePointApiName,
        upgradeConfig: upgradeConfig,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
        purchaseMotions: purchaseMotions
      })]
    })
  });
};
export default UpgradeHeroBanner;